import { CallMethod } from "csi/xml/CallMethod";
import declare from	"dojo/_base/declare";
import New from "csi/table/New";
import xml from	"csi/xml";

const NewFoodSKUDataSheetsController = declare(New, {

	relationshipId: null,
	/**
     * @override
     * Add Parameter ParentURL with the value of Food and Append the new Data Sheet to SKUSpecs on FoodSKU.
     */
	toWriterRequest: function() {
		const call = this.inherited<CallMethod>(arguments);
		call.addParameter("ParentURL", xml.ATTR_REF, this.getParent().__Parent__);
		this.m_writer.changeNode(this.m_urlParent).changeAttribute(this.relationshipId, xml.ATTR_REFLIST, [this.m_urlNode], true);
		return call;
	},

});

export = NewFoodSKUDataSheetsController;
